import {
  getGoogleWebClientId,
  getAppleWebClientId,
  getAppleRedirectUri,
} from '@/config/runtimeConfig';
import { isKnownRole, readStoredAuthUser } from '@/utils/sessionUser';

export const GOOGLE_WEB_CLIENT_ID = getGoogleWebClientId();
export const APPLE_WEB_CLIENT_ID = getAppleWebClientId();
export const appleRedirectUri = getAppleRedirectUri;

/** Extrai `sub` do JWT (Apple/Google) sem validar assinatura — só para enviar user_identifier; o backend valida. */
export function getJwtPayloadSub(idToken) {
  if (!idToken || typeof idToken !== 'string') return '';
  try {
    const part = idToken.split('.')[1];
    if (!part) return '';
    const json = atob(part.replace(/-/g, '+').replace(/_/g, '/'));
    const payload = JSON.parse(json);
    return payload.sub || '';
  } catch {
    return '';
  }
}

export const STAFF_PUBLIC_LOGIN_MESSAGE =
  'Esta conta é da equipe interna. Acesse o painel em /admin/login.';

export function isStaffPanelUser(user) {
  return user?.role === 'admin';
}

export function needsSocialProfileChoice(user) {
  if (!user) return false;
  return user.google_profile_completed === false || user.apple_profile_completed === false;
}

export function hasPersistedAuthSession() {
  return readStoredAuthUser() !== null && Boolean(localStorage.getItem('access_token'));
}

/** Destino pós-login (OAuth, e-mail, etc.). */
export function resolvePostAuthPath(user) {
  const resolvedUser = user || readStoredAuthUser();
  if (!resolvedUser || !isKnownRole(resolvedUser.role)) {
    return '/login';
  }
  if (needsSocialProfileChoice(resolvedUser)) {
    return '/escolher-perfil';
  }
  if (resolvedUser.role === 'client') return '/cliente/jobs';
  if (resolvedUser.role === 'videomaker') return '/videomaker/jobs';
  if (resolvedUser.role === 'admin') return '/admin/dashboard';
  return '/login';
}

export function dismissGoogleSignInUi() {
  try {
    window.google?.accounts?.id?.cancel?.();
  } catch {
    /* ignore */
  }
}

/** Navega para a área correta após auth bem-sucedida. */
export function redirectAfterAuth(user, navigate) {
  const path = resolvePostAuthPath(user);
  if (path === '/login') {
    return;
  }

  if (typeof window !== 'undefined' && window.location.pathname === path) {
    return;
  }

  if (navigate) {
    navigate(path, { replace: true });
    return;
  }

  if (typeof window !== 'undefined') {
    window.location.assign(path);
  }
}
